/**
 * @overview NEV认证评分
 * @author wuTao
 * @date 2022-05-05
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import 'antd/dist/antd.css';
import cloneDeep from 'lodash/cloneDeep'
import {Select} from 'antd';

let {Option} = Select;
let {WizContainer, WizReduxTemplatem, modelUtils} = framework_tool;
let {WizCard, WizIcon, WizTable, WizButton, WizModal, WizTabs, WizSelect, WizDataTable, WizSpin, WizInput, WizInputNumber, WizTimePicker, WizRow, WizCol, WizTypography} = component_tool;
let {checkStrLength, getPageData, Session} = utils_tool;
const {Title, Text, Paragraph} = WizTypography
const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/remoteAuth/lectureNevAuthDetail/score') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('nevRemoteAuthDetailRecordScore', record)
      } else {
        record = Session.get('nevRemoteAuthDetailRecordScore') || 0
      }
    }
  } else {
    record = Session.get('nevRemoteAuthDetailRecordScore') || 0
  }
  return record
}

class NevRemoteAuthScore extends WizContainer {

  componentName = 'nevRemoteAuthScore';

  constructor(props) {
    super(props);
    let initialValue = getParamRecord(props.history);
    const {jumpPageType} =initialValue;
    let backUrl = '/remoteAuth/lectureNevAuthDetail';
    if (jumpPageType==='nevDetailList'){
      backUrl = '/remoteAuth/nevRemoteAuthDetailList';
    }else if (jumpPageType==='nevDetail'){
      backUrl = '/remoteAuth/remoteAuthList/nevRemoteAuthDetail';
    }
    this.state = {
      infoList: [],//考卷模块
      tabIndex: 0,//当前tab标识
      dataItems: [],//列表数据
      totalScore: null,
      examId: null,
      tableKey: new Date().getTime(),
      backUrl: backUrl,
    }
    this.initialValue = initialValue;
  }

  _componentWillMount() {
    const {history} = this.props;
  }

  _componentDidMount() {
    this.getNevAuthExamPager()
  }

  /**获取考卷 */
  getNevAuthExamPager() {
    //
    if (this.initialValue.id) {
      this.doAction({
        path: 'nevRemoteAuthDetail/getNevRemoteAuthDetailExamInfo',
        payload: {
          key: 'nevRemoteAuthDetail/getNevRemoteAuthDetailExamInfo',
          apiParams: {
            id: this.initialValue.id
          }
        },
        autoInit: true,
      })
    }
  }

  /**保存单个模块数据 */
  saveNevExamPaper() {
    let {dataItems} = this.state;
    let {id, personId, remoteAuthId} = this.initialValue;
    let {examId} = this.state;
    let paperList = [];
    //先数据校验
    let errorMsg = '';
    if (examId === null || examId === undefined || examId === -1) {
      wizNotice.error('无有效考卷，请先获取考卷');
      return;
    }
    if (examId != null && dataItems && dataItems instanceof Array && dataItems.length > 0) {
      dataItems.forEach((value, index) => {
        const {moduleId, authQuestionId, authQuestionDetailId, score, mark, maxScore, minScore} = value;
        if (score === null || minScore > score || maxScore < score) {
          if (errorMsg === '') {
            errorMsg = '第' + (index + 1) + '行请选择有效学员得分';
          }
        } else if (score !== null && score !== -1 && minScore <= score && maxScore > score) {
          if (mark == null || mark === '') {
            errorMsg = '第' + (index + 1) + '行请输入扣分备注';
          }
        }
        paperList.push({moduleId, authQuestionId, authQuestionDetailId, score, mark})
      })
      if (errorMsg !== '') {
        wizNotice.error(errorMsg);
        return;
      }
      this.doAction({
        path: 'nevRemoteAuthDetail/saveNevExamPaper',
        payload: {
          key: 'nevRemoteAuthDetail/saveNevExamPaper',
          apiParams: {
            id, personId, remoteAuthId, examId,
            paperList: paperList
          }
        },
        autoInit: true,
      })
    }
  }

  propsAndStateOnChange = {
    nevRemoteAuthExamInfo: this.getNevRemoteAuthExamInfoOver.bind(this),
    saveNevExamPaper: this.saveNevExamPaperOver.bind(this)
  };

  /**
   * 获取考卷返回结果
   * @param nextProps
   * @param nextState
   */
  getNevRemoteAuthExamInfoOver(nextProps, nextState) {
    if (nextProps.nevRemoteAuthExamInfo.code == 1) {
      let data = nextProps.nevRemoteAuthExamInfo.data;
      const {infoList, examId} = data;
      let examInfoList = infoList && infoList instanceof Array ? cloneDeep(infoList) : [];
      examInfoList.forEach(element => {
        if (element.answers && element.answers instanceof Array) {
          element.answers.forEach(answer => {
            if (answer.score && answer.score < 0) {
              answer.score = undefined;
            }
          })
        }
      })
      nextState.infoList = examInfoList;
      nextState.examId = examId;
      let dataItems = [];
      let neoTotalScore = null;
      if (examInfoList && examInfoList instanceof Array) {
        let studentModuleRelation = [...examInfoList];
        dataItems = this._getAnswers(studentModuleRelation);
        dataItems.forEach(element => {
          const {score, minScore, maxScore, authQuestionDetailId} = element;
          element.key = authQuestionDetailId;
          if (score !== null && score !== -1 && minScore <= score && maxScore >= score) {
            if (neoTotalScore == null) {
              neoTotalScore = score;
            } else {
              neoTotalScore = neoTotalScore + score;
            }
          }
        });
      }
      nextState.totalScore = neoTotalScore;
      nextState.dataItems = dataItems;
      nextState.tableKey = new Date().getTime();
    } else {
      wizNotice.error('考卷加载失败：' + nextProps.nevRemoteAuthExamInfo.msg);
    }
    return true;
  }

  saveNevExamPaperOver(nextProps, nextState) {
    if (nextProps.saveNevExamPaper.code == 1) {
      wizNotice.success('操作成功');
      this.jumpPage('replace', this.state.backUrl && this.state.backUrl!='' ? this.state.backUrl : '/remoteAuth/lectureNevAuthDetail');
    } else {
      wizNotice.error('保存失败');
    }
    return true;
  }

  /** 改变行分数 */
  scoreChange(record, currentScore) {
    const {authQuestionDetailId} = record;
    let {dataItems} = this.state;
    let neoDataItems = cloneDeep(dataItems);
    let neoTotalScore = 0;
    if (neoDataItems && neoDataItems instanceof Array) {
      let studentModuleRelation = [...neoDataItems];
      let currentIndex = null;
      let neoValue = {};
      studentModuleRelation.forEach((value, index) => {
        const {score, minScore, maxScore} = value;
        if (value.authQuestionDetailId === authQuestionDetailId) {
          if (minScore <= currentScore && maxScore >= currentScore) {
            neoTotalScore = neoTotalScore + currentScore;
            currentIndex = index;
            neoValue = {...value, score: currentScore};
          }
        } else {
          if (score !== null && score !== -1 && minScore <= score && maxScore >= score) {
            neoTotalScore = neoTotalScore + score;
          }
        }
      })
      if (currentIndex != null) {
        neoDataItems[currentIndex] = neoValue;
      }
    }
    this.setState({dataItems: neoDataItems, totalScore: neoTotalScore});
  }


  /** 改变行扣分备注 */
  markChange(record, mark) {
    const {authQuestionDetailId} = record;
    let {dataItems} = this.state;
    let neoDataItems = cloneDeep(dataItems);
    if (neoDataItems && neoDataItems instanceof Array) {
      let studentModuleRelation = [...neoDataItems];
      let currentIndex = null;
      let neoValue = {};
      studentModuleRelation.forEach((value, index) => {
        if (value.authQuestionDetailId === authQuestionDetailId) {
          currentIndex = index;
          neoValue = {...value, mark: mark};
        }
      })
      if (currentIndex != null) {
        neoDataItems[currentIndex] = neoValue;
      }
    }
    this.setState({dataItems: neoDataItems});
  }

  createKeyValue = (key, value) => {
    let keyValue = {};
    keyValue[key] = value;
    return keyValue;
  }

  /** 创建表头 */
  createColumns() {
    let {infoList} = this.state;
    let columns = [];
    if (infoList && infoList instanceof Array) {
      let studentModuleRelation = [...infoList];
      let answers = [];
      let answersObj = {};
      let moduleObj = {};
      let questionRowNum = 0;
      studentModuleRelation.forEach(moduleInfo => {
        let moduleKeyValue = this.createKeyValue(questionRowNum, moduleInfo);
        moduleObj = {...moduleObj, ...moduleKeyValue}
        moduleInfo.answers.forEach(question => {
          question.authQuestionDetailScoreInfoList.forEach(questionDetail => {
            answers.push(questionDetail);
          })
          let questionKeyValue = this.createKeyValue(questionRowNum, question);
          answersObj = {...answersObj, ...questionKeyValue}
          questionRowNum = questionRowNum + question.authQuestionDetailScoreInfoList.length
        })
      });
      columns = [
        {
          title: '评价指标',
          name: 'moduleName',
          dataIndex: "moduleName",
          render(value, row, index) {
            const obj = {
              children: undefined,
              props: {rowSpan: 0},
            };

            Object.keys(moduleObj).forEach(_index => {
              if (_index == index + '') {
                let moduleValue = moduleObj[index]
                let moduleLength = 0
                moduleValue.answers.forEach(e => {
                  moduleLength = moduleLength + e.authQuestionDetailScoreInfoList.length
                })
                obj.children = <div dangerouslySetInnerHTML={{__html: moduleValue.moduleName}}></div>,
                  obj.props.rowSpan = moduleLength;
              }
            })
            return obj
          }
        },
        {
          title: '细项指标',
          name: 'questionName',
          dataIndex: "questionName",
          render: (value, row, index) => {
            const obj = {
              children: undefined,
              props: {rowSpan: 0},
            };
            Object.keys(answersObj).forEach(_index => {
              if (_index == index + '') {
                let questionValue = answersObj[index]
                obj.children = <div dangerouslySetInnerHTML={{__html: questionValue.questionName}}></div>,
                  obj.props.rowSpan = questionValue.authQuestionDetailScoreInfoList.length;
              }
            })
            return obj;
          }
        },
        {
          title: '评价标准',
          name: 'content',
          dataIndex: "content",
          render: (value, row, index) => {
            const obj = {
              children: <div dangerouslySetInnerHTML={{__html: value}}></div>,
              props: {},
            };
            return obj;
          }
        },
        {
          title: '满分',
          name: 'maxScore',
          dataIndex: "maxScore",
          render: (value, row, index) => {
            const obj = {
              children: <div style={{textAlign: "center"}} dangerouslySetInnerHTML={{__html: value}}></div>,
              props: {},
            };
            return obj;
          }
        },
        {
          title: '学员得分',
          name: 'score',
          dataIndex: "score",
          width: '10%',
          render: (text, record) => {
            const {maxScore, minScore, authQuestionDetailId} = record;
            let score = record.score
            if (score == -1 || score === null) {
              score = null;
            }
            let options = [];
            for (let i = minScore; i <= maxScore; i++) {
              options.push(<WizSelect.Option key={authQuestionDetailId + '_' + i} value={i}>
                <div style={{textAlign: "center"}}>{i}</div>
              </WizSelect.Option>)
            }
            return (
              <WizSelect
                key={authQuestionDetailId + '_select'}
                style={{width: "70px"}}
                defaultValue={score}
                onChange={(value) => {
                  this.scoreChange(record, value)
                }}
              >
                {
                  options
                }
              </WizSelect>
            )
          }
        },
        {
          title: '扣分备注',
          name: 'mark',
          dataIndex: "mark",
          render: (text, record) => {
            const {maxScore, score} = record;
            let mark = record.mark;
            let placeholder = '';
            if (score !== null && (score === -1 || maxScore > score)) {
              placeholder = '请输入扣分备注';
            }
            return (
              <WizInput max={50} value={mark} placeholde={placeholder} onChange={(e) => {
                this.markChange(record, e.target.value);
              }}/>
            )
          }
        },
      ]
    }
    return columns;
  }

  _getAnswers = (studentModuleRelation) => {
    let answers = [];
    if (studentModuleRelation && studentModuleRelation instanceof Array) {
      studentModuleRelation.forEach(moduleInfo => {
        const {moduleId} = moduleInfo;
        moduleInfo.answers.forEach(question => {
          const {authQuestionId} = question;
          question.authQuestionDetailScoreInfoList.forEach(questionDetail => {
            answers.push({...questionDetail, moduleId, authQuestionId});
          })
        })
      });
    }
    return answers;
  }

  /**列表 */
  detailList() {
    const {history, nevRemoteAuthDetailLoading} = this.props;
    let {infoList, dataItems} = this.state;
    let columns = this.createColumns();
    let dataTableProps = {
      loading: false,
      bordered: true,
      columns,
      dataSource: dataItems,
      rowKey: "authQuestionDetailId",
      rowSelection: null,
      showNum: false,
      isScroll: true,
      reasonable: true,
      pagination: false
    };
    return (
      <>
        <WizCard key={'data_' + this.state.tableKey} className="mt-15" tabBarExtraContent={this.tabBarExtraContent()}>
          {this.headChangeBtn()}
          <WizTable {...dataTableProps} />
          {this.submitBtn()}
        </WizCard>
      </>
    )
  }

  submitBtn() {
    let {infoList} = this.state;
    if (infoList && infoList.length > 0) {
      return (
        <div className="sumbit-btns">
          <WizButton style={{marginLeft: '45%', marginTop: '10px'}} type="primary" className="button"
                     onClick={() => this.saveNevExamPaper()}>保存</WizButton>
        </div>
      )
    }
  }

  headChangeBtn() {
    return (
      <div className="sumbit-btns" style={{display: "inline", marginRight: 40}}>
        <div style={{display: "inline"}}>
          <WizButton style={{marginBottom: '10px'}} className="button"
                     onClick={() => this.getNevAuthExamPager()}>更新评分表</WizButton>
        </div>
        <div style={{display: "inline", marginRight: '40px', marginBottom: '5px', float: "right"}}>
          {/*{this.tabBarExtraContent()}*/}
        </div>
      </div>
    )
  }

  /** 根据数据加载tab内容 */
  setTabs() {
    let {infoList} = this.state;
    let tabs = [];
    tabs.push(this.detailList());
    return tabs;
  }

  tabBarExtraContent() {
    return (
      <span>
        <span className=" ant-tabs-tab" style={{color: "rgba(0, 0, 0, 0.85)", fontWeight: 600,}}>总分:</span>
        <span className=" ant-tabs-tab"> {this.state.totalScore}</span>
      </span>
    )
  }


  /**
   * 头部：名称
   */
  _header = ({title, value, props}) => {
    return (
      <WizRow style={{padding: 0, marginLeft: "100px"}}>
        <WizCol span={8}>
          <Text strong {...props}>
            {title[0]}：{value[0]}
          </Text>
        </WizCol>
        <WizCol span={10}>
          <Text strong {...props}>
            {title[1]}：{value[1]}
          </Text>
        </WizCol>
        <WizCol span={6}>
          <Text strong {...props}>
            {title[2]}：{value[2]}
          </Text>
        </WizCol>
      </WizRow>
    )
  };

  _render() {
    const {history, nevRemoteAuthDetailLoading} = this.props;
    let {totalScore, infoList} = this.state;
    const {fullName, orgName, positionName} = this.initialValue;
    let titles = ['学员姓名', '新能源店', '岗位'];
    let values = [fullName, orgName, positionName];
    let headerProps = {title: titles, value: values}
    return (
      <WizSpin tip={'加载中'} spinning={nevRemoteAuthDetailLoading}>
        <WizCard title={'学员信息'} icon={0} key={new Date().getTime()}
                 bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
          <>
            {this._header(headerProps)}
          </>
        </WizCard>
        <WizCard title={'认证评分'} icon={0}>
          {this.setTabs()}
        </WizCard>
      </WizSpin>
    )
  }
}


const mapStateToProps = (state, ownProps) => {
  const {nevRemoteAuthDetail} = state;
  const nevRemoteAuthExamInfo = modelUtils.getModelEntity(nevRemoteAuthDetail, "nevRemoteAuthDetail/getNevRemoteAuthDetailExamInfo");
  const saveNevExamPaper = modelUtils.getModelEntity(nevRemoteAuthDetail, "nevRemoteAuthDetail/saveNevExamPaper");
  const load = modelUtils.getLoadingState(state, ['nevRemoteAuthDetail']);
  return {
    nevRemoteAuthExamInfo: nevRemoteAuthExamInfo,
    saveNevExamPaper: saveNevExamPaper,
    ...load
  }
};

export default connect(mapStateToProps)(NevRemoteAuthScore);

